export function getTicketsAsFC(tickets) {
  return {
    type: 'FeatureCollection',
    features: tickets.length > 0 ? tickets.flatMap((t) => t.asFeatures) : [],
  };
}
